import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'TipoSexo' })
export class SexoPipe implements PipeTransform {

  transform(tipo: number): string {
    switch (tipo) {
      case 1:
        return 'Hombre';
      case 2:
        return 'Mujer';
      case 3:
        return 'Niño';
      default:
        return '';
    }
  }
}
